import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const LoadNonprofitsEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => {
  const waitForCompletion = payload?.waitForCompletion !== false;

  return (
    <Box>
      <TextField
        fullWidth
        value={payload?.inputPath || ''}
        onChange={(e) => onChange({ ...payload, inputPath: e.target.value })}
        label="Input Path"
        placeholder="selectedNonprofitIds"
        helperText="Context path to array of nonprofit IDs"
        margin="normal"
      />
      <TextField
        fullWidth
        value={payload?.outputPath || ''}
        onChange={(e) => onChange({ ...payload, outputPath: e.target.value })}
        label="Output Path"
        placeholder="loadedNonprofits"
        helperText="Context path where loaded nonprofit data will be stored"
        margin="normal"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={waitForCompletion}
            onChange={(e) => onChange({ ...payload, waitForCompletion: e.target.checked })}
          />
        }
        label="Wait for loading to complete"
        sx={{ mt: 1, mb: 2 }}
      />

      {!waitForCompletion && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> Loading will continue in background. Ensure subsequent steps
            include a delay or use &quot;Wait for Context&quot; method to avoid accessing incomplete
            data.
          </Typography>
        </Alert>
      )}

      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          <strong>Input:</strong> Array of nonprofit IDs from context
          <br />
          <strong>Output:</strong> Array of loaded nonprofit objects
          <br />
          <strong>Features:</strong> Parallel loading, error recovery, filters out not-found
          nonprofits
          <br />
          <strong>Wait Option:</strong> When unchecked, continues flow immediately while loading in
          background
        </Typography>
      </Alert>
    </Box>
  );
};
